export function MissingSectionContents(): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-center text-sm font-medium text-gray-400">
      Coming Soon!
    </div>
  );
}
